import React from 'react';

import './styles.scss';

interface IWindowFrameProps {
    children: React.ReactNode;
}

export const WindowFrame = ({children}: IWindowFrameProps) => {
    return (
        <div className="window-frame">
            <div className="window-frame__topbar">
                <div className="window-frame__dot window-frame__dot--red" />
                <div className="window-frame__dot window-frame__dot--yellow" />
                <div className="window-frame__dot window-frame__dot--green" />
            </div>
            {children}
        </div>
    );
};